import axios from "axios";
// import jwt_decode from "jwt-decode";
import { jwtDecode } from 'jwt-decode';
import React, { useEffect, useRef, useState } from "react";
import { browserName, browserVersion } from "react-device-detect";
import { useLocation, useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { CardBody, Col, Row } from "reactstrap";
import {
    MDBBtn,
    MDBContainer,
    MDBCard,
    MDBCardBody,
    MDBCardImage,
    MDBRow,
    MDBCol,
    MDBIcon,
    MDBInput,
    MDBCheckbox,
    MDBAlert
} from 'mdb-react-ui-kit';
// import logImg from "../../components/images/Easy-MembrLogo.png";
import logImg from "../../components/images/easybook.png";
import { ClassesLoginImg } from '../../components/images/ClassAssets';
import { loginUser, getEnvFileData, logEvent } from "../../services/classApiServices.js";
import PageError from "../PageError.js";
import { getPricingPlansById } from "../../services/apiServices";
import { useAnalytics } from "../../hooks/useAnalytics";

function ClassesLogin({ setToken }) {
    const { trackButtonClick } = useAnalytics();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const emailSend = params.get('value');
    const [emailSent, setEmailSent] = useState(emailSend == "true" ? true : false);
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
        setIsPasswordVisible((prevState) => !prevState);
    };
    const userRef = useRef();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [apiError, setApiError] = useState(false);
    const [domain, setDomain] = useState("")
    // const CLIENT_ID =
    //   "102702637040-eau4e3o86jeoorqtveosi9fggnkduc7j.apps.googleusercontent.com";
    const navigate = useNavigate();

    const [ipaddress, setIpaddress] = useState()


    useEffect(() => {
        const currentUrl = window.location.href;
        const urlObj = new URL(currentUrl);
        const domain = urlObj.hostname;
        console.log(domain);
        setDomain(domain)
    }, []);

    useEffect(() => {
        userRef.current.focus();
    }, [navigate]);

    const handleReload = () => {
        window.location.reload();
    }
    useEffect(() => {
        setError("");
    }, [username, password]);




    const fetchEnvData = async () => {
        try {
            const response = await getEnvFileData();

            if (response.ok) {
                const data = await response.json();
                console.log("Environment Data:", data);

                if (data && data.length > 0) {
                    const firstEnvData = data[0];
                    localStorage.setItem("frontEndEnvData", JSON.stringify(firstEnvData));
                } else {
                    console.error("No data received from API or empty array");
                }
            } else {
                console.error("Failed to fetch environment data:", response.statusText);
            }
        } catch (e) {
            console.error("Error fetching environment data:", e);
        }
    };


    function setUserSession(userInfo) {
        localStorage.setItem("loggedUserInfo", JSON.stringify(userInfo));
    }



    const submitHandler = async (e, credentials) => {
        if (e) e.preventDefault();

        let currentIp = ipaddress;
        if (!currentIp) {
            try {
                const res = await axios.get("https://api.ipify.org?format=json");
                currentIp = res.data.ip;
                setIpaddress(currentIp);
            } catch (error) {
                console.error("Error fetching IP address:", error);
                currentIp = "--";
            }
        }
        let userInfo = {};
        if (credentials) {
            console.log(credentials);
            userInfo = await loginUser(credentials);
        } else {
            userInfo = await loginUser({
                username,
                password,
            });
        }
        console.log(userInfo);
        const jOBj = await userInfo.json();
        console.log(jOBj);
        try {
            if (userInfo === "false") {
                setApiError(true)
                return;
            }
            console.log(jOBj);
            console.log(jOBj.userInfo);
            if (userInfo.status !== 200) {
                console.log("Error occured :: " + userInfo.response.json.error);
                setError(userInfo.jsonjson.error);
            } else {
                if (!credentials) {
                    setWithExpiry("username", username, 0);
                    setWithExpiry("password", password, 0);
                }
                afterLogin(jOBj);
                setToken(jOBj.token);
                setUserSession(jOBj.userInfo);
                fetchEnvData();
                // navigate("/dashboard");


                const browserinfo = `${browserName || "Unknown"}-${browserVersion || "0"}.0.0`;
                const fullName = jOBj?.userInfo?.fname && jOBj?.userInfo?.lname
                    ? `${jOBj.userInfo.fname} ${jOBj.userInfo.lname}`
                    : jOBj.userInfo.name || "User";
                const username1 = jOBj.userInfo.email || "Guest";
                const gymid = jOBj.userInfo.gymid || "";
                const Eventtype = username1;

                const flag = `Class booking login successful (${fullName})`;

                await logEvent({
                    Eventtype,
                    username1,
                    ip: currentIp,
                    flag,
                    browserinfo,
                    gymid,
                    isclass: true,
                }, gymid);
            }
            trackButtonClick("ClassesLogin", "Staff_Login", "staff", {});
        } catch (e) {

            if (jOBj.errorr && jOBj.errorr.includes("Suspended")) {
                setError("This Gym account was Suspended!");
            } else if (jOBj.errorr && jOBj.errorr.includes("Deleted")) {
                setError("This Gym account was deleted!");
            } else if (jOBj.errorr && jOBj.errorr.includes("Unable") && jOBj.errorr.includes("staff")) {
                setError("Unable to login for the staff.");
            } else if (jOBj.errorr && jOBj.errorr.includes("Unable") && jOBj.errorr.includes("admin")) {
                setError("Unable to login for the admin.");
            } else {
                setError("Invalid Username/password");
            }
            console.log("Error::::::::::::" + e);
        }
    };

    let pagePath = "/classdashboard";
    async function afterLogin(jOBj) {
        let gymid = jOBj.userInfo.gymid;
        const response = await getPricingPlansById(gymid);
        const recinfo = await response.json();
        if (recinfo && (recinfo !== null)) {
            localStorage.setItem("planInfo", JSON.stringify(recinfo));
        }
        navigate(pagePath);
        try {

            const frontEndEnvData = localStorage.getItem("frontEndEnvData");
            const googleMapsApiKeydata = frontEndEnvData ? JSON.parse(frontEndEnvData)?.reactappipaddressurl : "https://api.ipify.org?format=json";
            // const url = 'https://api.ipify.org?format=json';

            const url = googleMapsApiKeydata
            const res = await axios.get(url);
            localStorage.setItem('ipaddress', res.data.ip);
        } catch (error) {
            console.error("Error fetching IP address:", error);
        }
        //   let ip = localStorage.getItem("ipaddress") || "--";
        //   let browserinfo = browserName + "-" + browserVersion + ".0.0";
        //   let Eventtype = "login";
        //   let flag = "Login Successfull";
        //   let username1 = jOBj.userInfo.email;
        //   logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, gymid);
    }
    useEffect(() => {
        let tsesson = false;
        async function fetchData() {
            try {
                if (JSON.parse(localStorage.getItem("loggedUserInfo")) && JSON.parse(localStorage.getItem("loggedUserInfo"))._id) {
                    console.log(JSON.parse(localStorage.getItem("loggedUserInfo"))._id);
                    tsesson = true;
                }
            } catch (e) {
                console.log("errore ::::::::::::::: " + e);
            }

            if (tsesson) {
                if (localStorage.getItem("loggedUserInfo")) {
                    let gymid = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;
                    const response = await getPricingPlansById(gymid);
                    const recinfo = await response.json();
                    if (!recinfo || recinfo == "false") {
                        return;
                    }
                    if (recinfo !== null) {
                        localStorage.setItem("planInfo", JSON.stringify(recinfo));
                    }
                }
                navigate("/classdashboard");
            } else {
                if (
                    localStorage.getItem("username") ||
                    localStorage.getItem("password")
                ) {
                    console.log(localStorage.getItem("username"));
                    console.log(JSON.parse(localStorage.getItem("username")));

                    setUsername(JSON.parse(localStorage.getItem("username")).value);
                    setPassword(JSON.parse(localStorage.getItem("password")).value);

                    let credentials = {
                        username: JSON.parse(localStorage.getItem("username")).value,
                        password: JSON.parse(localStorage.getItem("password")).value,
                    };
                    console.log(credentials);
                    submitHandler(null, credentials);
                } else {
                    /**
                     * Session error handling!
                     */
                    if (localStorage.getItem("SError")) {
                        setError(localStorage.getItem("SError"));
                        setTimeout(() => {
                            setError("");
                            localStorage.removeItem("SError");
                        }, 5000);
                    }
                }
            }
        }
        fetchData();
    }, [navigate]);

    function setWithExpiry(key, value, expiration) {
        const now = new Date();
        const item = {
            value: value,
            expiry: now.getTime() + expiration,
        };
        localStorage.setItem(key, JSON.stringify(item));
    }

    function responseGmail(resp) {
        console.log("response from gmail..");
        console.log(resp);
        submitHandler(null, {
            ...jwtDecode(resp.credential),
            username: jwtDecode(resp.credential).email,
            loginsource: "Google",
            password: "d3fault",
        });
    }



    try {
        useEffect(() => {

            try {
                let CLIENT_ID = "68288337026-6p3096b5r2ukcpvbvggtrgsinp72eegd.apps.googleusercontent.com";
                if (domain == "www.easymembr.com" || domain == "easymembr.com" || domain == "app.easymembr.com" || domain == "beta.easymembr.com") {
                    const frontEndEnvData = localStorage.getItem("frontEndEnvData");
                    CLIENT_ID = "102702637040-5o3s1v3v4dv3vndpo3pr3r3tic04npq1.apps.googleusercontent.com"
                }

                /* global google*/
                google.accounts.id.initialize({
                    client_id: CLIENT_ID + "",
                    callback: responseGmail,
                });
                google.accounts.id.renderButton(document.getElementById("signinDiv"), {
                    theme: "outline",
                    size: "large",
                });
            } catch (e) { }
        }, [domain]);
    } catch (e) { }




    return (
        <MDBContainer fluid className='p-0' >
            <div className="back-to-home">
                <Link to="/">
                    <MDBBtn>
                        <MDBIcon fas icon="arrow-left" />
                    </MDBBtn>
                </Link>
            </div>
            {apiError ? <PageError handleReload={handleReload} /> : <div className='d-flex align-items-center'>


                <div style={{ width: "650px" }} >
                    <div className="p-5 p-sm-0 d-flex align-items-center justify-content-center flex-column h-100vh sm-h-100vh mobileclasslogin">
                        <MDBCard className='mx-2 mb-3 p-5 custom-shadow rounded-5 w-70' style={{ background: 'hsla(0, 0%, 100%, 0.8)', backdropFilter: 'blur(30px)' }}>
                            <div className='d-flex flex-row mt-2'>
                                {/* <MDBIcon fas icon="cubes fa-3x me-3" style={{ color: '#ff6219' }} /> */}
                                {/* <span className="h1 fw-bold mb-0">Logo</span> */}
                                <img src={logImg} alt="" className='gymlogo1 p-0 m-0' style={{ width: "250px" }} />
                            </div>

                            <h5 className="fw-normal my-4 pb-3">Sign into your account</h5>
                            <div style={{ color: "red" }} className="mb-2">{error}</div>
                            <MDBInput wrapperClass='mb-4' label='Email / Mobile Number' id='formControlLg' type='email' size="lg"
                                // placeholder="Email / Mobile Number."
                                value={username}
                                ref={userRef}
                                onChange={(e) =>
                                    setUsername(e.target.value)
                                }
                            />
                            <div className="IconContainer">
                                <MDBInput wrapperClass='mb-2' label='Password' id='formControlLg' type={isPasswordVisible ? "text" : "password"} size="lg"
                                    // placeholder="Password"
                                    onChange={(e) =>
                                        setPassword(e.target.value)
                                    }
                                    value={password}
                                />
                                <MDBIcon fas icon={isPasswordVisible ? "eye-slash" : "eye"} className="inputIcon" onClick={togglePasswordVisibility} />

                            </div>
                            <div className="d-flex justify-content-between mb-4">
                                <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='Remember me' />
                                {/* <a href="!#">Forgot password?</a> */}
                            </div>


                            <MDBBtn className="mb-4 px-5 w-100" size='lg' onClick={submitHandler}>Login</MDBBtn>


                            {/* <MDBBtn className=" mb-4 w-100" size="lg" id="signinDiv"
                            >
                                <MDBIcon fab icon="google" className="mx-2" />
                                Sign in with google
                            </MDBBtn> */}
                            {/* <MDBBtn className="mb-4 w-100 d-flex align-items-center justify-content-center" size="lg"> */}
                            {/* <MDBIcon fab icon="google" className="mx-2" />
                            Sign in with Google */}
                            <div id="signinDiv" className=" w-100"></div>
                            {/* </MDBBtn> */}


                            <div className="text-center mt-3">
                                <p className="pb-lg-2" style={{ color: '#393f81' }}>
                                    Don't have an account?
                                    <Link to="/classsignup" className="p-0" style={{ color: '#393f81' }}> Register here</Link>
                                </p>
                            </div>



                        </MDBCard>
                        <div className='d-flex flex-row justify-content-start'>
                            <a href="#!" className="p-0 text-muted me-1">
                                &copy; {new Date().getFullYear()}
                            </a>
                            <a href="#!" className="p-0 text-muted">Zencruz.</a>
                        </div>

                    </div>

                </div>



                <div style={{ width: "calc(100vw - 650px)" }}>
                    <MDBCardImage src={ClassesLoginImg} alt="login form" className='rounded-0 w-100 h-100vh' style={{ objectFit: "cover" }} />
                </div>

            </div>}
            {emailSent &&
                <>
                    <MDBAlert
                        color="primary"
                        autohide
                        position='top-right'
                        delay={5000}
                        appendToBody
                        open={emailSent}
                        onClose={() => { setEmailSent(false) }}
                    >
                        <h6>We've sent your login credentials to your registered email address.<br /> Please check your inbox to log in your account.</h6>
                    </MDBAlert>
                </>
            }
        </MDBContainer>
    );
}

export default ClassesLogin